import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import classNames from 'classnames/bind';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';

import styles from './Sliders.module.scss';
import { dispatchPostError } from '~/redux/reducer/error';
import { logoutAccountSuccess } from '~/redux/reducer/auth';
import { requestPlayerGetSliders } from '~/services/slider';

const cx = classNames.bind(styles);

const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 6000,
};

function Sliders() {
    const [sliders, setSliders] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const fetch = async () => {
            const result = await requestPlayerGetSliders('VN', 'vi');

            if (result.status === 403) {
                dispatch(logoutAccountSuccess());
                localStorage.removeItem('_re');
                navigate('/');
                window.location.reload();
            } else if (result.status === 401) {
                dispatch(dispatchPostError(result));
            } else if (result.status === 200) {
                setSliders(result.data);
            }
        };
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={cx('wrapper')}>
            <Slider {...settings}>
                {sliders?.map((slider, index) => (
                    <div key={index}>
                        <a href={slider.link_url} target="_blank" rel="noreferrer">
                            <img src={slider.image_url} alt={slider.title} />
                        </a>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default Sliders;
